import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5006fdc6&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=5006fdc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006fdc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5006fdc6')) {
      api.createRecord('5006fdc6', component.options)
    } else {
      api.reload('5006fdc6', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=5006fdc6&scoped=true", function () {
      api.rerender('5006fdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/tools/rateCalculator/view.vue"
export default component.exports